import { createSelector } from "reselect";
import get from "lodash/get";

const civicSchemaSelector = createSelector(
  (state) => state.schema,
  (schema) => schema && schema.properties
);

const civicVariantSelector = createSelector(
  (state) => state.variantResult,
  (variantResult) => variantResult
);

const getCivic = createSelector(civicVariantSelector, (variantResult) => {
  return variantResult && variantResult.wustl_civic;
});

const civicPublicationsSelector = createSelector(
  civicVariantSelector,
  (variant) => get(variant, "publications.publications") || []
);

const civicLabelsSelector = createSelector(civicSchemaSelector, (schema) => {
  const path = "wustl_civic.items.properties.items.items.properties";
  return get(schema, path) || null;
});

const civicTitleSelector = createSelector(civicSchemaSelector, (schema) => {
  const path = "wustl_civic.title";
  return get(schema, path) || null;
});

const getTopClinicalEvidence = createSelector(getCivic, (data) => {
  let sortedResults = [];
  if (data && data.length > 0) {
    sortedResults = [].concat(data[0].items).sort((a, b) => {
      if (b?.rating === a?.rating) {
        const aa = JSON.stringify(a);
        const bb = JSON.stringify(b);
        return bb >= aa ? 1 : -1;
      }
      return b?.rating - a?.rating;
    });
  }
  if (sortedResults) {
    return sortedResults;
  }
  return null;
});

const getCivicGeneData = (state) =>
  __IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]?.civic
    : state?.variantResult?.civic;

export {
  civicSchemaSelector,
  civicVariantSelector,
  getCivic,
  civicPublicationsSelector,
  civicLabelsSelector,
  civicTitleSelector,
  getTopClinicalEvidence,
  getCivicGeneData,
};
